module.exports = __webpack_public_path__ + "img/desk.8056714d.png";